import { render, staticRenderFns } from "./chooseEvent.vue?vue&type=template&id=361738e8&scoped=true&"
import script from "./chooseEvent.vue?vue&type=script&lang=js&"
export * from "./chooseEvent.vue?vue&type=script&lang=js&"
import style0 from "./chooseEvent.vue?vue&type=style&index=0&id=361738e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361738e8",
  null
  
)

export default component.exports